import { booleanAttribute, Directive, input } from '@angular/core';

export type UiPrimaryNavigationItemVariant = 'default' | 'brand';

@Directive({
  selector: 'nav[appUiPrimaryNavigation]',
  host: {
    class:
      'app-ui-primary-navigation inline-flex h-10 items-center gap-2.5 bg-transparent p-0 text-text-on-header md:ml-4 md:gap-2',
  },
})
export class UiPrimaryNavigationDirective {}

@Directive({
  selector: 'a[appUiPrimaryNavigationItem], button[appUiPrimaryNavigationItem]',
  host: {
    '[attr.data-active]': "active() ? '' : null",
    '[attr.aria-current]': "active() ? 'page' : null",
    '[class]': 'classes()',
  },
})
export class UiPrimaryNavigationItemDirective {
  readonly active = input(false, { transform: booleanAttribute });
  readonly variant = input<UiPrimaryNavigationItemVariant>('default');

  protected classes(): string {
    const mobileGeometry =
      this.variant() === 'brand'
        ? 'max-md:h-nav-home max-md:w-nav-home max-md:gap-0 max-md:px-0'
        : 'max-md:h-action max-md:w-action max-md:gap-0 max-md:px-0';

    return [
      'app-ui-primary-navigation-item relative inline-flex h-action flex-none cursor-pointer items-center justify-center gap-2 rounded-lg border-0 bg-transparent px-3.5 text-text-on-header-muted transition-[background-color,color] duration-150',
      'hover:bg-surface-on-header-hover hover:text-text-on-header',
      'data-active:bg-surface-on-header-active data-active:text-text-on-header',
      'focus-visible:shadow-focus focus-visible:outline-none',
      mobileGeometry,
    ].join(' ');
  }
}
